VjsAdmin.SalesforceSettings = (() => {
    const init = () => {
        new SalesforceSettingClickEvent();

        // salesforceAccounts from /salesforce/index.twig
        // eslint-disable-next-line no-undef
        const selectData = $.map(salesforceAccounts, (obj) => {
            obj.text = `${obj.Name} - ${obj.Id}`;
            obj.id = obj.Id;

            return obj;
        });
        $('.salesforce-account-id-select2').select2({
            placeholder: 'No salesforce account selected',
            data: selectData,
            allowClear: true,
            theme: 'bootstrap4',
        });
    };

    let SalesforceSettingClickEvent = VjsUtility.Controller.extend({
        events: {
            'click .save-salesforce-id': 'clickSaveSalesforceId',
            'click .visit-salesforce': 'clickVisitSalesforce',
        },

        clickSaveSalesforceId: (e) => {
            const salesforceData = {
                ...e.target.closest('.save-salesforce-id').dataset,
                salesforceId: e.target.closest('.salesforce-group').querySelectorAll(':scope .sales-force-input')[0].value,
            };

            const req = new VjsUtility.Request();
            req.put(
                Slim.Router.pathFor('platforms.districts.salesforce.update', {
                    platform_id: salesforceData.platformId,
                    district_joint_guid: salesforceData.districtJointGuid,
                }),
                { salesforceData },
            )
                .done(() => {
                    VjsUtility.Notification.success('Salesforce ID saved successfully!');
                })
                .fail((x) => {
                    e.target.closest('.salesforce-group').querySelectorAll(':scope .sales-force-input')[0].selectedIndex = -1;
                    const group = e.target.closest('.salesforce-group');
                    const span = group.querySelector('.select2-selection__rendered');
                    span.textContent = 'No salesforce account selected';
                    const responseError = x?.responseJSON?.error?.message ?? 'Error saving Salesforce ID!';
                    VjsUtility.Notification.error(responseError);
                })
                .always(() => {});
        },
        clickVisitSalesforce: (e) => {
            const salesforceId = e.target.closest('.salesforce-group').querySelectorAll(':scope .sales-force-input')[0].value;
            const isValid = validateAccountID(salesforceId);
            if (!isValid) {
                VjsUtility.Notification.error("Please enter a valid Salesforce ID! Id's are 15 or 18 characters long.");
                return;
            }
            window.open(`https://pathful.lightning.force.com/lightning/r/Account/${salesforceId}/view`, '_blank');
        },
    });
    const validateAccountID = (accountID) => {
        const regex = /^[A-Za-z0-9]{15}$|^[A-Za-z0-9]{18}|^$/;
        return regex.test(accountID);
    };

    return {
        init,
    };
})();
